import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../Management/AuthContext";
import ButtonLogin from "../QuanTri1/ButtonLogin";
import NewManagement from "../QuanTri1/NewManagement";
import NewManagementDetail from "../QuanTri1/NewManagementDetail";
import CaseStudyDetail from "../QuanTri1/CaseStudyDetail";
import CaseStudyNew from "../QuanTri1/CaseStudyNew";

const fetchDataCategory = async () => {
  const response = await axios.get(
    "https://api-bluerise.bluerise.com.vn/category/get-all"
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

const fetchDataNews = async (tpe) => {
  const response = await axios.post(
    "https://api-bluerise.bluerise.com.vn/news/get-publish",
    {
      keyword: "",
      type: tpe,
      status: -1,
      pageNum: 1,
      pageSize: 100,
    }
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

export default function Tabss() {
  const { isAuthenticated, user, login, logout } = useAuth();
  const [activeTab, setActiveTab] = useState(1);
  const [categories, setCategories] = useState(null);
  const [news, setNews] = useState([]);
  const [caseStudies, setCaseStudies] = useState([]);
  const [editNews, setEditNews] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      fetchDataCategory().then((data) => {
        setCategories(data);
      });
      fetchDataNews(1).then((data) => {
        setNews(data);
      });
      fetchDataNews(2).then((data) => {
        setCaseStudies(data);
      });
    }
  }, [isAuthenticated]);

  return (
    <div className="flex h-full">
      {isAuthenticated ? (
        <>
          <div className="w-[350px] bg-[#dbf4ff] p-4 h-screen sticky top-0 rounded-lg">
            <button
              className={`py-2 px-4 text-sm font-medium w-full text-start cursor-pointer rounded-[8px] mb-2 ${
                activeTab === 1
                  ? "bg-[#27C6FF] text-white"
                  : "bg-transparent text-black"
              }`}
              onClick={() => setActiveTab(1)}
            >
              Quản Lý Tin Tức
            </button>
            <button
              className={`py-2 px-4 text-sm font-medium w-full text-start cursor-pointer rounded-[8px] ${
                activeTab === 2
                  ? "bg-[#27C6FF] text-white"
                  : "bg-transparent text-black"
              }`}
              onClick={() => {
                setEditNews(null);
                setActiveTab(2);
              }}
            >
              Viết bài mới
            </button>
            <button
              className={`py-2 px-4 text-sm font-medium w-full text-start cursor-pointer rounded-[8px] ${
                activeTab === 3
                  ? "bg-[#27C6FF] text-white"
                  : "bg-transparent text-black"
              }`}
              onClick={() => {
                setEditNews(null);
                setActiveTab(3);
              }}
            >
              Case Study Danh Sách
            </button>
            <button
              className={`py-2 px-4 text-sm font-medium w-full text-start cursor-pointer rounded-[8px] ${
                activeTab === 4
                  ? "bg-[#27C6FF] text-white"
                  : "bg-transparent text-black"
              }`}
              onClick={() => {
                setEditNews(null);
                setActiveTab(4);
              }}
            >
              Case Study Tạo Mới
            </button>
            <button
              className={`py-2 px-4 text-sm font-medium text-start w-full cursor-pointer rounded-[8px] mb-2 ${
                activeTab === 0
                  ? "bg-[#27C6FF] text-white"
                  : "bg-transparent text-black"
              }`}
              onClick={() => {
                logout();
              }}
            >
              Đăng xuất
            </button>
          </div>

          <div className="ml-6 w-full p-4 overflow-y-auto">
            {activeTab === 1 && (
              <div>
                <NewManagement
                  categories={categories}
                  news={news}
                  onEditNews={(id) => {
                    setEditNews(news.find((n) => n.id == id));
                    setActiveTab(2);
                  }}
                  onUpdateNews={(listUpdate) => setNews(listUpdate)}
                />
              </div>
            )}

            {activeTab === 2 && (
              <div>
                <NewManagementDetail
                  categories={categories}
                  newData={editNews}
                  onSaveData={() => {
                    fetchDataNews(1).then((data) => {
                      setNews(data);
                    });
                  }}
                />
              </div>
            )}
            {activeTab === 3 && (
              <div>
                <CaseStudyDetail
                  categories={categories}
                  news={caseStudies}
                  onEditNews={(id) => {
                    setEditNews(caseStudies.find((n) => n.id == id));
                    setActiveTab(4);
                  }}
                  onUpdateNews={(listUpdate) => setCaseStudies(listUpdate)}
                />
              </div>
            )}
            {activeTab === 4 && (
              <div>
                <CaseStudyNew
                  categories={categories}
                  newData={editNews}
                  onSaveData={() => {
                    fetchDataNews(2).then((data) => {
                      setCaseStudies(data);
                    });
                  }}
                />
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="flex items-center justify-center w-full h-screen">
          <ButtonLogin />
        </div>
      )}
    </div>
  );
}
